import React, { useState, useEffect, useContext } from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import Table from 'examples/Tables/Table';
import {
  CircularProgress, // Import CircularProgress
  Box, // Import Box
} from '@mui/material';

import { UserContext } from 'context/userContext';
import { userOrgs } from 'services/org';

function RecentOrgs({ orgs, onEdit, onDelete, refreshOrgs }) {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [localOrgs, setLocalOrgs] = useState([]); // Local org state
  const [loading, setLoading] = useState(true); // Add loading state

  const { userId } = useContext(UserContext);

  // Update localOrgs whenever orgs prop changes
  useEffect(() => {
    const getOrgs = async () => {
      if (!userId) {
        setLoading(false);
        setRows([]);
        return;
      }
      // -----------------------------

      if (!localOrgs || localOrgs.length === 0) {
        setLoading(false);
        setRows([]);
        return;
      }

      let getUserOrgs = await userOrgs(userId);

      if (getUserOrgs.data?.org) {
        setLocalOrgs(getUserOrgs.data.org || orgs || []);
      }
    };
    getOrgs();
  }, [orgs, userId]);

  useEffect(() => {
    setColumns([
      { name: 'name', align: 'left' },
      { name: 'details', align: 'left' },
    ]);

    const buildRows = async () => {
      setLoading(true); // Start loading
      try {
        const rowData = await Promise.all(
          localOrgs.map(async (org) => {
            return {
              name: (
                <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
                  {org.name}
                </ArgonTypography>
              ),
              details: (
                <ArgonTypography
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                  onClick={(e) => {}}
                >
                  View
                </ArgonTypography>
              ),
            };
          })
        );
        setRows(rowData);
      } catch (error) {
        console.error('Error building rows:', error);
        // Optionally show an error message to the user here, e.g., using a state variable
      } finally {
        setLoading(false); // Stop loading, regardless of success/failure
      }
    };

    buildRows();
  }, [localOrgs, onEdit, userId, refreshOrgs]); // Include refreshOrgs in dependencies

  return (
    <ArgonBox mb={1} mt={2}>
      <ArgonBox
        sx={{
          '& .MuiTableRow-root:not(:last-child)': {
            '& td': {
              borderBottom: ({ borders: { borderWidth, borderColor } }) => `${borderWidth[1]} solid ${borderColor}`,
            },
          },
        }}
      >
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" p={3}>
            <CircularProgress />
          </Box>
        ) : (
          <Table columns={columns} rows={rows} />
        )}
      </ArgonBox>
    </ArgonBox>
  );
}

export default RecentOrgs;
